import controller from './class-designer-comment-editor.controller';
import template from './class-designer-comment-editor.html';
import './class-designer-comment-editor.scss';

export default {
	controller,
	template,
	bindings: {
		disabled: '<?ngDisabled',
		selected: '<ngModel',
	},
	require: {
		editor: '^^classDesignerEditor',
	},
};
